// Swiper
import './swiper.js';
import { ofsaPostSlider } from './post-slider.js';
import { ofsaWhatSlider } from './what-slider.js';
import { ofsaHeaderImageSwitcher } from './header-image-switcher.js';
import { ofsaStickyTopbar } from './sticky-topbar.js';
import { ofsaPhotoSwipeGallery } from './photoswipe-gallery.js';

// Canvas overlay (must be imported before Alpine starts)
import './canvas-overlay.js';

// Alpine
import './alpine.js';

document.addEventListener(
	'DOMContentLoaded',
	() => {
		// Post slider
		ofsaPostSlider();

		// What slider
		ofsaWhatSlider();

		// Header image switcher
		ofsaHeaderImageSwitcher();

		// Sticky topbar
		ofsaStickyTopbar();

		// PhotoSwipe gallery
		ofsaPhotoSwipeGallery();
	},
	{ passive: true }
);
